export const LEAD_STATUSES = [
  'New Lead',
  'Contacted',
  'Waiting',
  'Interested',
  'Appointment Set',
  'Attended',
  'No-show',
  'Registered',
  'Lost',
  'Follow-up Later',
] as const;
export type LeadStatus = (typeof LEAD_STATUSES)[number];

export const LEAD_SOURCES = ['Website', 'Facebook', 'Referral', 'Walk-in', 'Phone', 'Other'] as const;
export type LeadSource = (typeof LEAD_SOURCES)[number];

/** openapi.yaml LeadResponse.attendanceResult / LeadStatusTransitionRequest.attendanceResult. */
export const ATTENDANCE_RESULTS = ['Attended', 'No-show'] as const;
export type AttendanceResult = (typeof ATTENDANCE_RESULTS)[number];
